import { createSlice } from "@reduxjs/toolkit";
import { getBillingInfoList, deleteBillingInfo } from "./BillingInfo.thunk";

const baseState = {
  billingInfoList: [],
  page: 1,
  pageSize: 5,
  totalPages: 0,
  totalRecords: 0,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  latestRequestId: null,
};

const initialState = {
  ...baseState,
};

export const billingInfoSlice = createSlice({
  name: "billingInfo",
  initialState,
  reducers: {
    ResetStore: (state) => {
      state = { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBillingInfoList.pending, (state, action) => {
        state.status = "loading";
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getBillingInfoList.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) {
          return;
        }

        const { billingInfoList, page, page_size, total_pages, total_records } =
          action.payload;
        state.status = "succeeded";
        state.billingInfoList = billingInfoList;
        state.page = page;
        state.pageSize = page_size;
        state.totalPages = total_pages;
        state.totalRecords = total_records;
        state.error = null;
      })
      .addCase(getBillingInfoList.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) {
          return;
        }

        state.status = "failed";
        state.billingInfoList = [];
        state.page = 1;
        state.pageSize = 5;
        state.totalPages = 0;
        state.totalRecords = 0;
        state.error =
          action?.payload?.message || "Unable to load billing information";
      });
    builder
      .addCase(deleteBillingInfo.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteBillingInfo.fulfilled, (state) => {
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(deleteBillingInfo.rejected, (state, action) => {
        state.status = "failed";
        state.error = action?.payload?.message || "Error deleting billing info";
      });
  },
});

export const { ResetStore } = billingInfoSlice.actions;

export default billingInfoSlice.reducer;
